export default $visitScheduleModal => {
  const getForm = () => $visitScheduleModal.form
  const getOpenModal = () => $visitScheduleModal.openModal

  return { getForm, getOpenModal }
}
